import { permissionValidation } from '@novafuturltd/shared'
import {
  AVATAR_BO_PERMISSION_LIST,
  type AvatarBoPermission,
} from './permissions'

export interface JwtClaims {
  organization_admin?: boolean
  admin?: boolean
}

export function decodeJwtClaims(token?: string): JwtClaims | null {
  if (!token) {
    return null
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    return null
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const json =
      typeof atob === 'function'
        ? atob(padded)
        : Buffer.from(padded, 'base64').toString('binary')

    return JSON.parse(json) as JwtClaims
  } catch {
    return null
  }
}

export function isOrganisationAdmin(token?: string): boolean {
  return decodeJwtClaims(token)?.organization_admin === true
}

const IMPLIED_BY_ORG_ADMIN = new Set<string>(AVATAR_BO_PERMISSION_LIST)

export interface MayPerformInput {
  permissions?: string[]
  accessToken?: string
  perform: AvatarBoPermission
}

export function mayPerform({
  permissions,
  accessToken,
  perform,
}: MayPerformInput): boolean {
  if (permissionValidation(permissions, perform)) {
    return true
  }

  return IMPLIED_BY_ORG_ADMIN.has(perform) && isOrganisationAdmin(accessToken)
}
